import React from 'react';

const Description = () => {
    return (
        <div>
            <p>
                <strong>Potential Payout</strong> is a suite of helpers
                functions that returns the potential payout of a bet selection
                in betslip. The potential payout utils is displayed considering
                outcome/s values and if it's betBuilder outcome, selected
                reward, stake/s amount betslip tab, betOffer eachWay info,
                teaser selected.
            </p>
            <p>
                Please click on <strong>the helpers below</strong> to get more
                information about this helper function.
            </p>
        </div>
    );
};

export default Description;
